import { DEFAULT_CURRENCY } from './constants';

/**
 * Parses what people type into a price field ("49,90", "1.299,00 €", "12.5")
 * into cents. Returns null for an empty field and NaN for anything that
 * isn't a non-negative amount.
 */
export function parseMoney(input: string | null | undefined): number | null {
  if (input == null) return null;
  let v = String(input).trim().replace(/[€\s]/g, '');
  if (!v) return null;
  // German format: dots group thousands, the comma is the decimal separator
  if (v.includes(',')) v = v.replace(/\./g, '').replace(',', '.');
  // "1.299" without a comma is a thousands separator too, not 1,30 €
  else if (/^\d{1,3}(\.\d{3})+$/.test(v)) v = v.replace(/\./g, '');
  if (!/^\d*\.?\d*$/.test(v)) return NaN;
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : NaN;
}

const formatters = new Map<string, Intl.NumberFormat>();

export function formatMoney(cents: number, currency = DEFAULT_CURRENCY): string {
  let f = formatters.get(currency);
  if (!f) {
    f = new Intl.NumberFormat('de-DE', { style: 'currency', currency });
    formatters.set(currency, f);
  }
  return f.format(cents / 100);
}

/** The value to put back into a price input: 4990 → "49,90", 0 → "". */
export function centsToInput(cents: number): string {
  if (!cents) return '';
  const s = (cents / 100).toFixed(2).replace('.', ',');
  return s.endsWith(',00') ? s.slice(0, -3) : s;
}
